import { insertTextAfterSelection, replaceTextSelection } from '@lyearn/lygo-blocks';
import { EditorView } from '@lyearn/lygo-core';

interface EditorFunctionParams {
  editorView: EditorView;
  suggestion: string | null;
  onDone: () => void;
}

export function replaceSelection({ editorView, suggestion, onDone }: EditorFunctionParams) {
  if (!suggestion) return;
  replaceTextSelection(editorView, suggestion, true);
  onDone();
}

export function insertBelow({ editorView, suggestion, onDone }: EditorFunctionParams) {
  if (!suggestion) return;
  insertTextAfterSelection(editorView, suggestion, true);
  onDone();
}

export function keepSuggestion({ editorView, suggestion, onDone }: EditorFunctionParams) {
  replaceSelection({ editorView, suggestion, onDone });
}

export function discardSuggestion({ editorView, suggestion, onDone }: EditorFunctionParams) {
  onDone();
}
